
import { createFormHook, createFormHookContexts } from "@tanstack/react-form";
import Field from "./ui/Field";


export const { fieldContext, formContext, useFieldContext, useFormContext } = createFormHookContexts();

const { useAppForm } = createFormHook({
	fieldContext,
	formContext,
	fieldComponents: {
		Date: Field.Date,
		Input: Field,
		Select: Field.Select,
		Enum: Field.Enum,
		Image: Field.Image
	},
	formComponents: {}
});

export const useForm = useAppForm;